import { HttpContext, HttpContextToken } from '@angular/common/http';

export class Auth {
  authkey: string | null;
  authemail: string | null;
}

export const SKIP_AUTHENTICATION = new HttpContextToken<boolean>(() => false);
export const SKIP_SPINNER_LOADING = new HttpContextToken<boolean>(() => false);
export const SKIP_MODAL_ERROR = new HttpContextToken<(number | 'all')[]>(() => [])
export const IS_TOOL = new HttpContextToken<string | false>(() => false);

export function skipAuthentication() {
  return new HttpContext().set(SKIP_AUTHENTICATION, true);
}

export function skipSpinnerLoading(){
  return new HttpContext().set(SKIP_SPINNER_LOADING, true);
}

export function skipModalError(statuses: (number | 'all')[]){
  return new HttpContext().set(SKIP_MODAL_ERROR, statuses);
}

export function isTool(tool:string | false ){
  return new HttpContext().set(IS_TOOL, tool);
}
